import mixin from '@witkac/bootstrap4-components/src/mixins/formMixin';
import components from '@witkac/bootstrap4-components/src/components/formComponents';
import FormDatepicker from '@/components/FormDatepicker.vue';

/**
 * @vuese
 * @group mixins
 *
 * Mixin formularzy, przyspiesza importowanie `@witkac/bootstrap4-components`
 */
export const formMixin = {
  mixins: [mixin],
  components: { ...components, FormDatepicker },
  external: {}
};
